import { createApp, nextTick } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { waitForPageStyles } from './startup-styles'
import '@fontsource/bricolage-grotesque/latin-600.css'
import '@fontsource/bricolage-grotesque/latin-700.css'
import '@fontsource/spline-sans-mono/latin-400.css'
import '@fontsource/spline-sans-mono/latin-500.css'
import './styles/app.css'

declare global {
  interface Window {
    __cquBoot?: { ready(): void; fail(reason?: string): void; wait(): void; step(stage: 'entry' | 'router' | 'styles' | 'mounted'): void }
  }
}

window.__cquBoot?.step('entry')
const app = createApp(App)
app.use(createPinia())
app.use(router)
// Keep a real, dependency-free recovery screen until the first route is ready.
router.onError(() => window.__cquBoot?.fail('router'))
let renderFailed = false
let mounted = false
let stylesReady = false
function reveal() {
  if (mounted && stylesReady && !renderFailed) window.__cquBoot?.ready()
}
app.config.errorHandler = (error) => {
  renderFailed = true
  console.error(error)
  window.__cquBoot?.fail('render')
}
router.beforeEach(() => window.__cquBoot?.wait())
router.afterEach((_to, _from, failure) => {
  if (!failure)
    void nextTick().then(() => {
      reveal()
    })
})
// The route mounts independently of CSS: login, APIs and scene downloads must
// not be held hostage by a lost stylesheet event. Keep the small boot overlay
// until CSS is actually attached, so the full page is never shown unstyled.
void waitForPageStyles().then(() => {
  stylesReady = true
  window.__cquBoot?.step('styles')
  reveal()
}).catch(() => window.__cquBoot?.fail('styles'))

void router.isReady().then(() => {
  window.__cquBoot?.step('router')
  app.mount('#app')
  mounted = true
  window.__cquBoot?.step('mounted')
  reveal()
}).catch(() => window.__cquBoot?.fail('mount'))
